<template>
  <div class="input-text-copy">
    <component
      :is="monospaced ? 'pre' : 'div'"
      class="input-text-copy__text"
      :style="{
        'white-space': inLine ? 'nowrap' : undefined,
      }"
    >
      {{ displayedText }}
    </component>

    <div>
      <QmulusButton
        :icon="icon"
        severity="secondary"
        is-inline-action
        :label="t('copy')"
        @click="copy"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  shallowRef,
} from 'vue';

import useLibraryI18n from '../../i18n/composable.ts';
import QmulusButton from '../button/qmulus-button.vue';

const props = defineProps<{
  copyString: string,
  label?: string,
  inLine?: boolean,
  /**
   * When set to true, a monospaced font will be used to display the text.
   */
  monospaced?: boolean,
}>();

const {
  t,
} = useLibraryI18n('components/text-copy/text-copy');

const displayedText = props.label || props.copyString;

const icon = shallowRef('pi pi-copy');

function copy() {
  navigator.clipboard.writeText(props.copyString)
    .then(() => {
      icon.value = 'pi pi-check';
      setTimeout(() => {
        icon.value = 'pi pi-copy';
      }, 500);
    });
}
</script>

<style scoped lang="scss">
.input-text-copy {
  border: 1px solid var(--border-color-strong);
  border-radius: var(--border-radius);
  display: grid;
  grid-template-columns: 1fr auto;

  &__text {
    padding: var(--gap);
    overflow-x: auto;
    word-break: break-all;
  }
}
</style>
